// projects/domain/ach/tax-payments/tax-template.entity.ts
import { AchBatchSummaryModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../shared';
import { TaxType } from './types';

export class TaxTemplate extends DomainEntity<AchBatchSummaryModelDto> {
    public createDefault(): this {
        return new TaxTemplate({
            id: 0,
            name: '',
            achCompanyName: '',
            achPaymentTypeId: TaxType.Federal,
            lastUpdated: '',
            creditAmount: 0,
            debitAmount: 0,
            status: 'Ready',
            permissions: [],
            isEdited: false,
            numberOfRecipients: 0,
            errorMessage: '',
        } as unknown as AchBatchSummaryModelDto) as this;
    }

    public get id(): number {
        return this.dto.id ?? 0;
    }

    public get name(): string {
        return this.dto.name ?? '';
    }

    public get achCompanyName(): string {
        return this.dto.achCompanyName ?? '';
    }

    public get type(): TaxType {
        // achPaymentTypeId is present on search results but not in the DTO type definition
        const typeId = (this.dto as unknown as { achPaymentTypeId?: number }).achPaymentTypeId;
        return typeId === TaxType.State ? TaxType.State : TaxType.Federal;
    }

    public get typeLabel(): string {
        return this.type === TaxType.Federal ? 'Federal' : 'State';
    }

    public get lastUpdated(): Date {
        return new Date(this.dto.lastUpdated ?? '');
    }

    public get totalAmount(): number {
        return this.dto.creditAmount ?? 0;
    }

    public get formattedAmount(): string {
        return this.totalAmount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }

    public get status(): string {
        return this.dto.status ?? '';
    }

    public get permissions() {
        return this.dto.permissions ?? [];
    }

    public get canApprove(): boolean {
        return this.permissions.some(p => p.permission === 'Approve');
    }

    public get canReject(): boolean {
        return this.permissions.some(p => p.permission === 'Reject');
    }

    public get canDelete(): boolean {
        return this.permissions.some(p => p.permission === 'DeleteBatch');
    }
}
